import { gql } from "@apollo/client";

export const GET_OBJECTS_PAGED = gql`
  query GetObjectsPaged($input: ByProjectIdReqInput!) {
    mdmObjectsByProjectIdPaged(req: $input) {
      items {
        address {
          fullAddress
        }
        id
        location {
          latitude
          longitude
        }
        customFields {
          key
          value {
            type
            value
          }
        }
        tags
        title
        identifier
      }
      pageInfo {
        skip, take, total
      }
    }
  }
`;

export const GET_OBJECTS_BY_PROJECT = gql`
  query GetObjectsByProject($id: String!){
    mdmObjectsByProjectId(projectId: $id) {
      id
      identifier
      title
      address {
        fullAddress
      }
      customFields {
        key
        value {
          type
          value
        }
      }
    }
  }
`;

export const GET_OBJECT = gql`
  query GetObject($id: String!) {
    mdmObjectById(id: $id) {
      address {
        city
        country
        houseNumber
        postCode
        street
        fullAddress
      }
      customFields {
        key
        value {
          type
          value
        }
      }
      boundDatasets {
        all {
          dataset {
            identifier
            title
          }
        }
        indirect {
          dataset {
            identifier
            title
          }
        }
        direct {
          dataset {
            identifier
            title
          }
        }
        mapped {
          dataset {
            identifier
            title
          }
        }
      }
      description
      deviceRelations {
        mdmDevice {
          id
          identifier
          tags
          modifiedAt
          createdAt
          status {
            status
            lastMeasurementDate
          }
          customFields {
            key
            value {
              type
              value
            }
          }
        }
        roleInObject
      }
      id
      location {
        latitude
        longitude
      }
      tags
      title
      identifier
      info {
        jobsCount
        notesCount
      }
    }
  }
`;

export const CREATE_OBJECT = gql`
  mutation CreateObject($object: MdmObjectDTOInput!) {
    createMdmObject(input: $object) {
      id
      title
      identifier
      description
      tags
      address {
        city
        country
        houseNumber
        postCode
        street
      }
      location {
        latitude
        longitude
      }
    }
  }
`;

export const UPDATE_OBJECT = gql`
  mutation UpdateObject($object: MdmObjectDTOInput!) {
    updateMdmObject(input: $object) {
      id
      title
      identifier
      description
      tags
      address {
        city
        country
        houseNumber
        postCode
        street
      }
      location {
        latitude
        longitude
      }
    }
  }
`;

export const DELETE_OBJECT = gql`
  mutation DeleteObject($id: String!) {
    deleteMdmObject(id: $id) {
      id
      identifier
      title
    }
  }
`;
